@if (show) {
<mat-horizontal-stepper linear [labelPosition]="config?.labelPosition || 'bottom'" (selectionChange)="onSelectionChange($event)" #stepper
    [selectedIndex]="selectedIndex" [disableRipple]="config?.disableRipple || true">
    
        <mat-step *ngFor="let step of steps; let i = index" [label]="step.label" [completed]="step.isComplete">
            <router-outlet *ngIf="stepper.selectedIndex===i"></router-outlet>
        </mat-step>
    </mat-horizontal-stepper>
}